<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <app-modal-header-ui [title]="title"></app-modal-header-ui>

  <div class="dialog-body">
    <ng-container *ngIf="isMe">
      <mat-progress-bar *ngIf="loadingDetail" mode="indeterminate"></mat-progress-bar>
      <div class="impact-warning" *ngIf="detailError" role="alert">
        <mat-icon>error_outline</mat-icon>
        <span>{{ detailError }}</span>
        <button type="button" mat-button color="primary" (click)="loadDetail()" i18n="@@retry">Retry</button>
      </div>
    </ng-container>

    <!-- Applicant Information -->
    <div class="section">
      <h3 i18n="@@applicantInformation">Applicant Information</h3>
      <div class="applicant-card">
        <div class="applicant-header">
          <div class="applicant-info">
            <strong>{{ request.staff?.name }}</strong>
            <span class="applicant-meta" *ngIf="request.department?.name">{{ request.department?.name }}</span>
          </div>
          <span class="leave-badge" [style.background-color]="getLeaveTypeColor()">
            {{ request.policy?.name }}
          </span>
        </div>
      </div>
    </div>

    <!-- Leave Request Details -->
    <div class="section">
      <h3 i18n="@@leaveDetails">Leave Details</h3>
      <div class="details-grid">
        <div class="detail-item">
          <span class="detail-label" i18n="@@startDate">Start Date:</span>
          <span class="detail-value">{{ formatDate(request.startDate) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label" i18n="@@endDate">End Date:</span>
          <span class="detail-value">{{ formatDate(request.endDate) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label" i18n="@@days">Days:</span>
          <span class="detail-value days-badge">{{ request.days }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label" i18n="@@appliedOn">Applied On:</span>
          <span class="detail-value">{{ formatDate(request.createdDate) }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label" i18n="@@status">Status</span>
          <span class="detail-value">{{ request.status | titlecase }}</span>
        </div>
        <div class="detail-item" *ngIf="request.decidedOn">
          <span class="detail-label" i18n="@@decidedOn">Decided On</span>
          <span class="detail-value">{{ formatDate(request.decidedOn) }}</span>
        </div>
      </div>

      <div class="reason-section" *ngIf="request.reason">
        <h4 i18n="@@reason">Reason</h4>
        <p>{{ request.reason }}</p>
      </div>

      <div class="reason-section" *ngIf="request.decisionNote">
        <h4 i18n="@@decisionNote">Decision Note</h4>
        <p>{{ request.decisionNote }}</p>
      </div>

      <div class="details-grid">
        <div class="detail-item" *ngIf="request.reviewer?.name">
          <span class="detail-label" i18n="@@designatedApprover">Designated Approver</span>
          <span class="detail-value">{{ request.reviewer?.name }}</span>
        </div>
        <div class="detail-item" *ngIf="request.relievingOfficer?.name">
          <span class="detail-label" i18n="@@relievingOfficer">Relieving Officer:</span>
          <span class="detail-value">{{ request.relievingOfficer?.name }}</span>
        </div>
      </div>
    </div>

    <!-- Review Comment -->
    <div class="section" *ngIf="canDecide">
      <form [formGroup]="reviewForm">
        <mat-form-field class="w-full" appearance="outline">
          <mat-label i18n="@@reviewComment">Review Comment</mat-label>
          <input matInput formControlName="reviewComment" maxlength="500"
                 placeholder="Optional comment" i18n-placeholder="@@optionalComment">
          <mat-hint align="end">{{ reviewForm.get('reviewComment')?.value?.length || 0 }}/500</mat-hint>
        </mat-form-field>
      </form>
    </div>

    <div class="impact-warning" *ngIf="mode === 'review' && isSelfRequest" role="alert">
      <mat-icon>info</mat-icon>
      <span i18n="@@cannotDecideOwnLeave">You cannot approve or reject your own leave request</span>
    </div>

    <div class="impact-warning" *ngIf="errorMessage" role="alert">
      <mat-icon>warning</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- Actions -->
    <div class="dialog-actions">
      <ng-container *ngIf="canDecide">
        <app-button-icon-ui
          *ngIf="canReject"
          [buttonType]="'button'"
          [isDisabled]="!!submitting"
          classNames="p-3 py-4 rounded-xl text-white bg-error/90 hover:bg-error w-[150px]"
          i18n-name="@@reject"
          name="Reject"
          value="reject"
          [icon]="'close'"
          (clickEmit)="decide('reject')"
        ></app-button-icon-ui>

        <app-button-icon-ui
          *ngIf="canApprove"
          [buttonType]="'button'"
          [isDisabled]="!!submitting"
          classNames="p-3 py-4 rounded-xl text-white bg-success/90 hover:bg-success w-[150px]"
          i18n-name="@@approve"
          name="Approve"
          value="approve"
          [icon]="'check'"
          (clickEmit)="decide('approve')"
        ></app-button-icon-ui>
      </ng-container>

      <app-button-icon-ui
        *ngIf="canCancel"
        [buttonType]="'button'"
        classNames="p-3 py-4 rounded-xl text-white bg-error/90 hover:bg-error w-[150px]"
        i18n-name="@@cancelApplication"
        name="Cancel Application"
        value="cancel-leave"
        (clickEmit)="requestCancel()"
      ></app-button-icon-ui>

      <app-button-icon-ui
        [buttonType]="'button'"
        classNames="p-3 py-4 rounded-xl border border-secondary opacity-80 hover:opacity-100 text-secondary w-[150px]"
        i18n-name="@@close"
        (clickEmit)="close()"
        name="Close"
        value="close"
      ></app-button-icon-ui>
    </div>
  </div>
</div>
